import React from 'react';
import PropTypes from 'prop-types';

export default class Image extends React.Component {

    static get propTypes() {

        return {
            className: PropTypes.string,
            alt: PropTypes.string,
            src: PropTypes.string,
        };
    }

    render() {
        return (
            <img
                className={ this.props.className }
                alt={ this.props.alt }
                src={ this.props.src } />
        );
    }

}